const adminLuckyRouter = [
  {
    path: '/admin/lucky',
    name: 'AdminLuckyIndex',
    component: () => import('@/views/admin/lucky/index')
  },
  {
    path: '/admin/lucky/create',
    name: 'AdminLuckyCreate',
    component: () => import('@/views/admin/lucky/create')
  },
  {
    path: '/admin/lucky/edit',
    name: 'AdminLuckyEdit',
    component: () => import('@/views/admin/lucky/edit')
  },
  {
    path: '/admin/lucky/link',
    name: 'AdminLuckyLink',
    component: () => import('@/views/admin/lucky/link')
  },
  {
    path: '/admin/lucky/result',
    name: 'AdminLuckyResult',
    component: () => import('@/views/admin/lucky/result')
  }
]
export default adminLuckyRouter



// WEBPACK FOOTER //
// ./src/router/modules/admin/lucky.js